/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';

class TablesMenu extends React.Component {

    render() {
        return (
            <section id="tables">

            </section>

        );
    }
}

export default connect(state=> ( {}))(TablesMenu);



// WEBPACK FOOTER //
// ./src/browser/tables/TablesMenu.js